import {Component, Input, SimpleChanges, OnChanges} from '@angular/core';
import {WordProvider} from "../../providers/word/word";
import { ModalController, ToastController } from "ionic-angular";

/**
 * Generated class for the HotQuestionComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'hot-question',
  templateUrl: 'hot-question.html'
})
export class HotQuestionComponent implements OnChanges{

  text: string;
  @Input() scope;
  @Input() choosedChatroom;


  constructor(private wordService:WordProvider,public _modal:ModalController) {
    console.log('Hello HotQuestionComponent Component');
    this.text = 'Hello World';
  }

  ngOnChanges(changes:SimpleChanges){
    this.question_list = [];
    this.getHotQuestion();
  }
  //显示命中记录
  is_loading:boolean = false;
  is_error:boolean = false;
  question_list = [];
  getHotQuestion(){
    this.is_loading = true;
    this.is_error = false;
    this.wordService.getHotQuestion(this.choosedChatroom?this.choosedChatroom.chatroomname:null,this.scope.value).subscribe(res => {
        this.is_loading = false;
        this.is_error = false;
        //TODO:main function
        this.question_list = res['content']['hot_question_data'];
      },
      err => {
        this.is_loading = false;
        this.is_error = true;
      })
  }


  showWordDetail(word){
    let modal = this._modal.create('WordRecordPage',{
      chatroomname:this.choosedChatroom?this.choosedChatroom.chatroomname:null,
      scope:this.scope.value,
      keyword:word,
    });
    modal.present();
    modal.onDidDismiss(() =>{

    })
  }
}



// WEBPACK FOOTER //
// ./src/components/hot-question/hot-question.ts